<template>
	<div class="col-md-3 col-sm-12 col-xs-12 popup-side" :class="componentClass">
		<i class="fa fa-gavel margin-bottom-50" aria-hidden="true"></i>
		<span class="section-title-line"></span>
		<h3 class="margin-bottom-50">{{ $t(title) }}</h3>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'ModalSide',
	props: {
		componentClass: {
			type: String,
			default: '',
		},
		title: {
			type: String,
			required: true,
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ModalSide.vue